import axios from 'axios'

export const batchFetch = async function (keys) {
  const token = window.localStorage.getItem('auth_token')
  try {
    const result = await axios.post('api.public.Public/GetUserKeys', { keys }, {
      headers: { Authorization: token }
    })
    const results = result.data.records
    return results
  } catch (error) {
    //
  }
}

export const fetchUserFilter = async function (name, config) {
  try {
    const result = await axios.post('api.public.Public/GetUserKeys', { key: name }, config)
    const filter = result.data.records ? JSON.parse(result.data.records[name]) : null
    if (filter) {
      return filter
    }
  } catch {
    //
  }
}

export const setUserFilter = async function (name, value) {
  const token = window.localStorage.getItem('auth_token')
  try {
    await axios.post('api.public.Public/UpsertUserKey', { key: name, value: JSON.stringify(value) }, {
      headers: { Authorization: token }
    })
  } catch {
    //
  }
}

export const resetUserFilters = async function (config) {
  try {
    const result = await axios.post('api.public.Public/GetUserKeys', {}, config)
    Object.keys(result.data.records).forEach(async (key) => {
      await axios.post('api.public.Public/DeleteUserKey', { key }, config)
    })
  } catch {
    //
  }
}
